import React, { createContext, useContext } from 'react';

const DuperbrowseDisabledContext = createContext(false);
DuperbrowseDisabledContext.displayName = 'DuperbrowseDisabledContext';

export function useDuperbrowseDisabled() {
  return useContext(DuperbrowseDisabledContext);
}

export const DuperbrowseDisabled: React.FC<React.PropsWithChildren> = ({ children }) => (
  <DuperbrowseDisabledContext.Provider value={true}>{children}</DuperbrowseDisabledContext.Provider>
);
DuperbrowseDisabled.displayName = 'DuperbrowseDisabled';

export default DuperbrowseDisabledContext;
